import '@ui5/webcomponents/dist/BusyIndicator.js';
import { BusyIndicatorSize } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `BusyIndicator` signals that some operation is going on and that the user must wait. It does not block the current UI screen so other operations could be triggered in parallel. It displays 3 dots and each dot expands and shrinks at a different rate, resulting in a cascading flow of animation.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/BusyIndicator" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const BusyIndicator = withWebComponent('ui5-busy-indicator', ['delay', 'size', 'text'], ['active'], [], []);
BusyIndicator.displayName = 'BusyIndicator';
BusyIndicator.defaultProps = {
    delay: 1000,
    size: BusyIndicatorSize.Medium
};
export { BusyIndicator };
